<template>
    <div>
        <div class="card-body text-center">
            <div class="button-group">
                <button @click="acceptContract" class="btn btn-primary" type="button">Accept</button>
<!--                <button class="btn btn-danger" data-target="#confirmModalDelContract" data-toggle="modal" type="button">Delete</button>-->
            </div>
        </div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                If the contract is in DRAFT state, you can post(Set all the details of this contract as final and publish) or you can delete the whole contract.
            </p>
        </div>
        <!-- MODAL FOR CONFIRMATION -->
        <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModalDelContract" role="dialog" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="text-center m-t-20 m-b-10">
                            <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                            <br><br>
                            <h4>Are you sure you want to remove this contract?</h4>
                            <button @click="deleteContract" class="btn waves-effect waves-light btn-success m-r-15" data-dismiss="modal" type="button">Yes</button>
                            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">No</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "MarketplaceContractAccept",
        props: ["contractid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        methods: {
            async acceptContract() {
                await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/${this.contractid}/accept`, {
                    comments: ''
                });
                this.$root.$emit('refreshContract');
                this.$toastr('success', 'Contract status updated successfully', 'Contract Updating');
            },
            async deleteContract() {
                await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/${this.contractid}`);
                await this.$router.push({name: 'contracts'});
                this.$toastr('success', 'Contract deleted successfully', 'Contract Deletion');
            }
        }
    }
</script>

<style scoped>

</style>
